import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const TatByCity = ({
    tat,
    className=""
   
}) => {
    const [isMounted, setIsMounted] = useState(false);
    const HOOKCITY = useSelector((state) => state?.hookCity?.cityId);
    useEffect(() => {
        setIsMounted(true);
    }, []);

    if (!isMounted) return null; // Avoid hydration mismatch
    const tatByCity = tat && tat[HOOKCITY];
    return (
        <p className={`${className}`}>

            {tatByCity?.tat_by || "1-5 day(s)"}
            
        </p>
    );
};

export default TatByCity;
